import * as filterHeaderTypes from '../../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../../common/helpermethods/HelperMethods';


export const PAGE_REFRESH_RATE = 600000;

export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'EOD Date',
        type: filterHeaderTypes.filterTypes.date,
        defaultValue: { from: lastWorkingDay(), to: null, today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        fromOnly: true,
        fixed: true,
        singleDay: true,
        hideAllButton: true,
        hideToday: true
    },
    {
        id: 'counterparty',
        title: 'Counterparty',
        type: filterHeaderTypes.filterTypes.radioList,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/counterparties',
        server: true,
        fixed: true,
        wide: true,
        includeGroupTitle: false
    },
    {
        id: 'csa',
        title: 'CSA',
        type: filterHeaderTypes.filterTypes.radioList,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/csas',
        server: true,
        fixed: true,
        includeGroupTitle: false
    }
];

export const defaultFilters = [
    {
        value: {
            from: lastWorkingDay(),
            to: null,
            today: false
        },
        definition: filterDefinitions.find(def => def.id === 'runDate')
    },
    {
        value: [],
        definition: filterDefinitions.find(def => def.id === 'counterparty')
    },
    {
        value: [],
        definition: filterDefinitions.find(def => def.id === 'csa')
    }
];
